import { render, staticRenderFns } from "./BDXEditFormAccountType.vue?vue&type=template&id=3a26793e"
import script from "./BDXEditFormAccountType.vue?vue&type=script&lang=js"
export * from "./BDXEditFormAccountType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports